<section class="head">
    <h3>Inline Edit</h3>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor</p>
</section>

<section class="body">
    <div class="segment">
        <h4>Inline Edit</h4>
        <hr>
        <div class="partition">
            <div class="segment">
                <!-- <msc-common-inline-edit [value]="text" (changeEvent)="onChange($event)"></msc-common-inline-edit> -->
            </div>
        </div>
    </div>
</section>
